import {BsThreeDotsVertical} from "react-icons/bs";

export default function Blessedness({ bless, incr }) {
  return (
    <div className="bless-card" style={{background:incr}}>
      <div className="d-flex justify-content-between mb-2">
        <h4 className="text-muted">{bless.date}</h4>
        <BsThreeDotsVertical size='25px'/>
      </div>
      <h3 className="mb-3 text-dark">{bless.gratitude}</h3>
      <h4 className="text-muted">{bless.time}</h4>
    </div>
  );
}
